
import { PermissionKey, PlanType } from '@/common/permission';
import { hasPermission as _hasPermission } from '../utils';

export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    isRechargePlan: function isRechargePlan() {
      return this.authorizeInfo.plan_type === PlanType.Recharge;
    }
  },
  data: function data() {
    return {
      PermissionKey: PermissionKey
    };
  },

  methods: {
    hasPermission: function hasPermission(key) {
      return _hasPermission(this.authorizeInfo.permissions || '', key);
    }
  }
};